import { commonTranslationKeys, FormContextValues } from '@dreryk/react-common';
import { ClassNameProp, TextInput } from '@dreryk/react-components';

import { SERVICE_PROVIDING_LOCATION_NAME_VALIDATION_RULES } from '../../../common/serviceProvidingLocation';

const TOKEN = 'serviceProvidingLocationNameInput';

type ServiceProvidingLocationNameInputProps = Pick<
   FormContextValues<{ serviceProvidingLocationName: string | null }>,
   'register'
> &
   ClassNameProp;

export const ServiceProvidingLocationNameInput = (props: ServiceProvidingLocationNameInputProps): JSX.Element => {
   return (
      <TextInput
         testId={'name'}
         label={commonTranslationKeys.name}
         controller={props.register('serviceProvidingLocationName', SERVICE_PROVIDING_LOCATION_NAME_VALIDATION_RULES)}
         className={TOKEN}
      />
   );
};

ServiceProvidingLocationNameInput.Token = TOKEN;
